import React, { useContext } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import UserService from '#/services/UserService';
import { UserContext } from './App';
import { useForm, Controller } from 'react-hook-form';
import { SpinnerView } from './parts/SpinnerView';

function Logout() {
  const ctx = useContext(UserContext);
  const service = new UserService(ctx.userInfo!);
  const { control, handleSubmit, formState, reset } = useForm();

  const onSubmit = (values: any) => {
    service
      .signOut()
      .then((_) => {
        ctx.setUserInfo(null);
      })
      .finally(() => reset());
  };

  return (
    <Container fluid className="h-100 mt-4">
      <Row>
        <Col>
          <h4>ログアウト</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group>
              <Controller
                control={control}
                name="submit"
                render={({ field: { ref } }) => (
                  <Button type="submit" disabled={formState.isSubmitted}>
                    {formState.isSubmitted ? (
                      <SpinnerView size="sm" />
                    ) : (
                      'ログアウトする'
                    )}
                  </Button>
                )}
              />
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default Logout;
